import { useAppDispatch } from "../../redux";
import type { IBirthDateInputProps } from "../../types";
import { setBirthDate } from "../RegistrationPage/RegistrationPageSlice";
import moment from "moment";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";

export default function BirthDateInput(props: IBirthDateInputProps) {
  const { errors, label, birthDate, setErrors } = props;

  const dispatch = useAppDispatch();

  const handleDateChange = (value: moment.Moment | null) => {
    if (!value || value.format("YYYY-MM-DD") === "Invalid date")
      return setErrors({
        ...errors,
        birthDate: true,
      });
    else
      setErrors({
        ...errors,
        birthDate: false,
      });

    dispatch(setBirthDate(value.format("YYYY-MM-DD")));
  };

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <DesktopDatePicker
        sx={{ my: 3 }}
        format="MM/DD/YYYY"
        className="dateOfBirth"
        label={`${label} MM/DD/YYYY`}
        value={moment(birthDate)}
        onChange={handleDateChange}
        disableFuture
        views={["year", "month", "day"]}
        slotProps={{
          textField: {
            helperText: "e.x 12/31/1940",
            error: errors.birthDate,
            type: "tel",
            required: true,
            fullWidth: true,
          },
        }}
      />
    </LocalizationProvider>
  );
}
